import { Logger } from '~~/helpers/logger';

import CustomPayment from '~~/constants/customPayment';
import { ORDER_WITHOUT_EMAIL_ID } from '~~/constants/log';

const useCheckout = () => {

  const error = useState('useCheckout-error', () => ({ createCashPayment: false, createBankPayment: false }));
  const loadingModule = useLoading('useCheckout-loading');

  const {
    user,
  } = useUserExtended();
  const { updateCustomerEmail } = useCartExtended();
  const { clientEmail, setClientEmail } = useClientEmailStore();
  const { paymentSelected, setPaymentSelected } = usePaymentSelectedStore();
  const { countryCode: country } = useLocalization();

  const isPaymentCodSelected: ComputedRef<boolean> = computed(() => paymentSelected.value === CustomPayment.COD);
  const isPaymentBankSelected: ComputedRef<boolean> = computed(() =>
    paymentSelected.value === CustomPayment.BANK_TRANSFER);

  const postEmail = async (updateCart = true) => {

    const newEmail = user.value?.email || clientEmail.value;

    if (!newEmail) {

      Logger.error(`${ORDER_WITHOUT_EMAIL_ID} postEmail called with empty email`);

      return;
    
    }
    setClientEmail(newEmail);

    if (updateCart) {

      await updateCustomerEmail(newEmail, 'postEmail');
    
    }
  
  };

  const setErrorCreateBankPayment = (errorCreatePayment: boolean) => {

    error.value.createBankPayment = errorCreatePayment;
  
  };

  const setErrorCreateCashPayment = (errorCreatePayment: boolean) => {

    error.value.createCashPayment = errorCreatePayment;
  
  };

  const defaultAddress = {
    country: country.value,
  };

  return {
    loadingModule,
    postEmail,
    error,
    setErrorCreateCashPayment,
    setErrorCreateBankPayment,
    isPaymentCodSelected,
    isPaymentBankSelected,
    setPaymentSelected,
    paymentSelected,
    defaultAddress,
  };

};
export default useCheckout;
